import React from 'react';

// A small, consistent stroke vocabulary; decorative icons never replace labels.
export default function Icon({ name = 'arrow-up-right', size = 20, className = '' }) {
  const paths = {
    'arrow-up-right': <path d="M6 18 18 6M6 6h12v12" />,
    'arrow-right': <path d="M4 12h16m-7-7 7 7-7 7" />,
    'arrow-left': <path d="M20 12H4m7-7-7 7 7 7" />,
    'arrow-down': <path d="M12 4v16m-7-7 7 7 7-7" />,
    mail: <><rect x="3" y="5" width="18" height="14" /><path d="m3 6 9 7 9-7" /></>,
    check: <path d="m5 12 4 4L19 6" />,
    book: <><path d="M4 3h13l3 3v15H4zM8 3v18M12 8h4M12 12h4" /></>,
    smile: <><path d="M4 18V6l8-3 8 3v12l-8 3z"/><path d="M8 9v2m8-2v2m-7 4q3 3 6 0" /></>,
  };
  return <svg className={`f1000-icon ${className}`} width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">{paths[name] || paths['arrow-up-right']}</svg>;
}
